import React from 'react'
import styled from 'styled-components'
import Icon, { IconOption } from 'components/Icon'
import { colors } from 'utils'

const S = {
    Wrapper: styled.div`
        position: relative;
        cursor: pointer;
        display: inline-block;
        width: 30px;
        height: 30px;
        text-align: center;
    `,
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    icon: IconOption
    active?: boolean
}

const OptionButton = ({ icon, active, ...props }: Props) => (
    <S.Wrapper {...props}>
        <Icon
            icon={icon}
            size={18}
            style={{ marginTop: '2px' }}
            color={active ? colors.primary : colors.icon}
        />
    </S.Wrapper>
)

export default OptionButton
